/**
 * Truncation module
 * @exports wowTruncate
 * @description Utility module for truncating lines of text.
 * The element requires a height and overflow: hidden;.
 * to be set by css
 * @requires jQuery dotdotdot plugin
 * @tutorial http:dotdotdot.frebsite.nl
 */

require('dotdotdot');

module.exports = function () {
    return {
        restrict: 'A',
        link(scope, element) {

        element.dotdotdot({
            watch: true,
            dots: true
        });

    }

};
}
;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/truncation/truncate.js
 **/